import { render, staticRenderFns } from "./v-quote.vue?vue&type=template&id=a01414b6&scoped=true&"
import script from "./v-quote.vue?vue&type=script&lang=js&"
export * from "./v-quote.vue?vue&type=script&lang=js&"
import style0 from "./v-quote.vue?vue&type=style&index=0&id=a01414b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01414b6",
  null
  
)

export default component.exports